import { render, staticRenderFns } from "./catalogointernas.vue?vue&type=template&id=1c74c1ea&scoped=true"
import script from "./catalogointernas.vue?vue&type=script&lang=js"
export * from "./catalogointernas.vue?vue&type=script&lang=js"
import style0 from "./catalogointernas.vue?vue&type=style&index=0&id=1c74c1ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c74c1ea",
  null
  
)

export default component.exports